module.exports = __webpack_public_path__ + "static/media/padlock-grey.820246bc.svg";